import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import PatientRegistration from "../../components/patientRegistration/patientRegistration"
import "./list.scss"
// import PatientFilter from "../../components/patient-timeline/patientFilter"

const PatientContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <PatientRegistration />
        </>
      </div>
    </div>
  )
}

export default PatientContainer